import {StudentModelV2} from 'resources/GeneratedModels/Student/StudentModel.v2';
import {userModelExtensions} from 'resources/augmented/User/user.extensions';

StudentModelV2.extend(userModelExtensions);

export {StudentModelV2};
